/* global google */
import {useEffect, useState} from 'react';
import {IntlShape, useIntl} from 'react-intl';

import {useLocalesMgr} from 'coreHooks';

import {useStoreLocatorContext} from 'brand/app/pages/store-locator/context/StoreLocatorContext';
import messages from 'brand/app/pages/store-locator/messages';

interface IInfoWindowWrapperProps {
	hasStorePage?: boolean
}

const InfoWindowWrapper = ({hasStorePage = false}: IInfoWindowWrapperProps) => {
	const intl: IntlShape = useIntl();
	const localesMgr = useLocalesMgr();
	const {map, selectedStoreMarker} = useStoreLocatorContext();
	const [infoWindow, setInfoWindow] = useState<google.maps.InfoWindow>();

	useEffect(() => {
		if (!google?.maps?.InfoWindow) {
			return;
		}

		setInfoWindow(new google.maps.InfoWindow({disableAutoPan: false}));
	}, [google.maps.InfoWindow]);

	useEffect(() => {
		if (!infoWindow) {
			return;
		}

		if (!selectedStoreMarker) {
			infoWindow.close();

			return;
		}

		const store = selectedStoreMarker.store;
		const link = localesMgr.updateLinkWithLocale(`/store-detail?StoreID=${store.ID}`);

		const storePageLink = hasStorePage && store.isEnabledMoreDetailsLink
			? `<div class="store-more">
				<a href=${link}>
					${intl.formatMessage(messages.moreDetails)}
				</a>
			</div>`
			: '';

		infoWindow.setContent(`
			<div class="store-locator-map-info-window">
				<div class="store-title">
					${store.name}
				</div>
				<div>${store.address1 || ''} ${store.address2 || ''}</div>
				<div>${store.postalCode || ''} ${store.city || ''} (${store.countryCode})</div>
				<div class="store-contacts">
					<div class="store-tel">
						<a href="tel:${store.phone}">
							${store.phone}
						</a>
					</div>
					${storePageLink}
				</div>
			</div>
		`);

		infoWindow.open(map, selectedStoreMarker.marker);

		return () => infoWindow.close();
	}, [map, infoWindow, selectedStoreMarker]);

	return false;
};

export default InfoWindowWrapper;